export default __webpack_public_path__ + "static/image-API-text-gen-04ab8b1c9a5ae6789debe410d5ba4262.png";